import alert from 'angular-ui-bootstrap/src/alert';
import modal from 'angular-ui-bootstrap/src/modal';
import translate from 'angular-translate';

/* global angular */
angular.module('atex.aceui.ui', [alert, modal, translate]);
